<div class="is-fullwidth">

    <div class="is-flex is-column gap-16 is-flex-grow-1 is-space-between">
      <div class="home-modes is-flex gap-24 is-space-between">
        <app-home-mode-schedules class="is-flex-grow-1"></app-home-mode-schedules>
        <app-home-mode-selection></app-home-mode-selection>
      </div>

      <app-home-mode-end-date></app-home-mode-end-date>
    </div>

</div>
